import { serializeDatetime } from '@Pages/pageRuntime/lib/dateFormatter';

/** A window bound as the scheduling endpoints read it. An invalid `Date` is an empty string. */
export function schedulingRequestDatetime(value: Date | string): string {
  if (typeof value === 'string') {
    return value;
  }

  return Number.isNaN(value.getTime()) ? '' : serializeDatetime(value);
}
